import { c as _c } from "react/compiler-runtime";
import { keycloakAuthorisePrivileged } from '@/app/lib/rest';
import { QueryParams } from '@/helpers/filter';
import { TSRException } from '@/helpers/rest';
import { useRouter } from '@/i18n/routing';
import { PrivilegedAuthorisation } from '@diamond-block/api/v1/self-service/schema/keycloak';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { FormProvider, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import z from 'zod/v3';
import { ErrorDisplay } from '../feedback/ErrorDisplay';
import { FormControl } from '../forms/FormControl';
const PrivilegedRequestFormData = PrivilegedAuthorisation.extend({
  actionType: z.enum(['confirm', 'request'])
});
export const PrivilegedRequestForm = () => {
  const $ = _c(59);
  const t = useTranslations("PrivilegedRequestForm");
  const {
    push
  } = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(PrivilegedRequestFormData),
      defaultValues: {
        actionType: "confirm"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const form = useForm(t0);
  const {
    handleSubmit,
    formState: t1,
    register
  } = form;
  const {
    isSubmitting
  } = t1;
  let t2;
  if ($[1] !== push || $[2] !== t) {
    t2 = async data => {
      await toast.promise(keycloakAuthorisePrivileged({
        body: {
          email: data.email
        }
      }).then(_temp), {
        loading: t("requesting"),
        success: res_0 => {
          const params = new QueryParams();
          if (data.actionType === "request") {
            params.set("request", res_0.body.requestToken);
          } else {
            if (data.actionType === "confirm") {
              params.set("confirm", res_0.body.confirmToken);
            }
          }
          setTimeout(() => push(`?${params.toString()}`));
          return t("successfully-requested");
        },
        error: _temp2
      });
    };
    $[1] = push;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleSubmit || $[5] !== t2) {
    t3 = handleSubmit(t2);
    $[4] = handleSubmit;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      required: true
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("email");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("email-placeholder");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <FormControl options={t4} field="email" label={t5} placeholder={t6} type="email" />;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("action-method");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <legend className="fieldset-legend">{t8}</legend>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== register) {
    t10 = register("actionType");
    $[19] = register;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isSubmitting || $[22] !== t10) {
    t11 = <input type="radio" className="radio-primary radio mr-2" value="confirm" {...t10} disabled={isSubmitting} aria-disabled={isSubmitting} />;
    $[21] = isSubmitting;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("do-action");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <label className="my-2 flex cursor-pointer items-center">{t11}{t12}</label>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== register) {
    t14 = register("actionType");
    $[29] = register;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isSubmitting || $[32] !== t14) {
    t15 = <input type="radio" className="radio-primary radio mr-2" value="request" {...t14} disabled={isSubmitting} aria-disabled={isSubmitting} />;
    $[31] = isSubmitting;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("send-email");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <label className="my-2 flex cursor-pointer items-center">{t15}{t16}</label>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t13 || $[40] !== t17 || $[41] !== t9) {
    t18 = <fieldset className="fieldset">{t9}{t13}{t17}</fieldset>;
    $[39] = t13;
    $[40] = t17;
    $[41] = t9;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== isSubmitting) {
    t19 = isSubmitting && <span className="loading loading-spinner" />;
    $[43] = isSubmitting;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t) {
    t20 = t("request");
    $[45] = t;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== isSubmitting || $[48] !== t19 || $[49] !== t20) {
    t21 = <div className="flex flex-row justify-end p-2"><button className="btn btn-primary" disabled={isSubmitting} type="submit">{t19}{t20}</button></div>;
    $[47] = isSubmitting;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t18 || $[52] !== t21 || $[53] !== t3 || $[54] !== t7) {
    t22 = <form onSubmit={t3}>{t7}{t18}{t21}</form>;
    $[51] = t18;
    $[52] = t21;
    $[53] = t3;
    $[54] = t7;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== form || $[57] !== t22) {
    t23 = <FormProvider {...form}>{t22}</FormProvider>;
    $[56] = form;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  return t23;
};
function _temp(res) {
  if (res.status !== 201) {
    throw new TSRException(res);
  }
  return res;
}
function _temp2(err) {
  return <ErrorDisplay err={err} />;
}